// extracted by mini-css-extract-plugin
module.exports = {"checkoutDetailCallback":"DetailCallback-Jtails_checkoutDetailCallback_3hQJO","previousCart":"DetailCallback-Jtails_previousCart_1JKtP"};